export default "__VITE_ASSET__09vNga$Z__"